import {Doughnut} from "vue-chartjs";
import updateChartMixin from "@/components/widgets/updateChartMixin";
import i18n from "@/i18n";

export default {
    extends: Doughnut,
    mixins: [updateChartMixin],
    props: {
        options: {
            type: Object,
            default: () => null
        },
        unApprovedPassengersWithoutIdsToday: {
            type: Number,
            required: true
        },
        unApprovedPassengersWithIdsToday: {
            type: Number,
            required: true
        }
    },
    computed: {
        data() {
            return {
                datasets: [{
                    label: i18n.t("inputs.unapprovedPassengersPieChart.label"),
                    data: [this.unApprovedPassengersWithIdsToday, this.unApprovedPassengersWithoutIdsToday],
                    backgroundColor: ["#F00", "#F0F"]
                }],
                labels: [i18n.t('inputs.unapprovedPassengersPieChart.withIds'), i18n.t('inputs.unapprovedPassengersPieChart.withoutIds')]
            }
        }
    },
    mounted() {
        this.renderChart(this.data, this.options);
    }
};